module.exports = __webpack_public_path__ + "img/girl.0174a7b5.png";